import pizzaStatue from 'game/sprites/images/pizza-statue.png';

export const LabSprite = (
  <>
    <path fill="#1a1a1a" d="M1502 292H3502V1422H1502z" />
    <rect
      width="1500"
      height="940"
      x="1532"
      y="1962"
      opacity="0.2"
      rx="123.13"
    />
    <path
      d="M4462 1342H3452v-250H1462v270a99.52 99.52 0 00-60-20H102A100 100 0 002 1442v420a100 100 0 00100 100h1300a100 100 0 00100-100v-50h1560v50a100 100 0 00100 100h1300a100 100 0 00100-100v-420a100 100 0 00-100-100z"
      opacity="0.2"
    />
    <path
      fill="#b3b3b3"
      stroke="#666"
      strokeWidth="4"
      d="M118.5 1512v319c0 12.15 17.24 22 38.5 22s38.5-9.85 38.5-22v-319zM1298.5 1512v319c0 12.15 17.24 22 38.5 22s38.5-9.85 38.5-22v-319z"
    />
    <path
      fill="#ccc"
      stroke="gray"
      strokeWidth="4"
      d="M1653.5 2451.5v319c0 12.15 17.24 22 38.5 22s38.5-9.85 38.5-22v-319zM2833.5 2451.5v319c0 12.15 17.24 22 38.5 22s38.5-9.85 38.5-22v-319z"
    />
    <path
      fill="#b3b3b3"
      stroke="#666"
      strokeWidth="4"
      d="M3178.5 1512v319c0 12.15 17.24 22 38.5 22s38.5-9.85 38.5-22v-319zM4358.5 1512v319c0 12.15 17.24 22 38.5 22s38.5-9.85 38.5-22v-319z"
    />
    <rect
      width="1500"
      height="970"
      x="2"
      y="602"
      fill="#e6e6e6"
      stroke="gray"
      strokeWidth="4"
      rx="100"
    />
    <rect
      width="1500"
      height="620"
      x="2"
      y="202"
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      rx="100"
    />
    <rect
      width="1258.06"
      height="520"
      x="122.97"
      y="202"
      fill="#e6e6e6"
      stroke="gray"
      strokeWidth="4"
      rx="83.87"
    />
    <rect
      width="1258.06"
      height="520"
      x="122.97"
      y="102"
      fill="#e6e6e6"
      stroke="gray"
      strokeWidth="2"
      rx="83.87"
    />
    <rect
      width="1258.06"
      height="520"
      x="122.97"
      y="2"
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      rx="83.87"
    />
    <rect
      width="1500"
      height="970"
      x="1532"
      y="602"
      fill="#e6e6e6"
      stroke="gray"
      strokeWidth="4"
      rx="100"
    />
    <rect
      width="1500"
      height="620"
      x="1532"
      y="202"
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      rx="100"
    />
    <rect
      width="1258.06"
      height="520"
      x="1653.94"
      y="202"
      fill="#e6e6e6"
      stroke="gray"
      strokeWidth="4"
      rx="83.87"
    />
    <rect
      width="1258.06"
      height="520"
      x="1653.94"
      y="102"
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      rx="83.87"
    />
    <rect
      width="1500"
      height="970"
      x="3062"
      y="602"
      fill="#e6e6e6"
      stroke="gray"
      strokeWidth="4"
      rx="100"
    />
    <rect
      width="1500"
      height="620"
      x="3062"
      y="202"
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      rx="100"
    />
    <rect
      width="1258.06"
      height="520"
      x="3183.94"
      y="202"
      fill="#e6e6e6"
      stroke="gray"
      strokeWidth="4"
      rx="83.87"
    />
    <rect
      width="1258.06"
      height="520"
      x="3183.94"
      y="102"
      fill="#e6e6e6"
      stroke="gray"
      strokeWidth="2"
      rx="83.87"
    />
    <rect
      width="1258.06"
      height="520"
      x="3183.94"
      y="2"
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      rx="83.87"
    />
    <path
      fill="#1a1a1a"
      d="M2932 1262H1632a100 100 0 01-100-100v310a100 100 0 00100 100h1300a100 100 0 00100-100v-310a100 100 0 01-100 100zM2932 932H1632a100 100 0 01-100-100v220a100 100 0 00100 100h1300a100 100 0 00100-100V832a100 100 0 01-100 100z"
    />
    <path
      fill="#e6e6e6"
      d="M2932 1082H1632a100 100 0 01-100-100v10a100 100 0 00100 100h1300a100 100 0 00100-100v-10a100 100 0 01-100 100z"
    />
    <path
      fill="#e6e6e6"
      d="M2932 1002H1632a100 100 0 01-100-100v10a100 100 0 00100 100h1300a100 100 0 00100-100v-10a100 100 0 01-100 100z"
    />
    <path
      fill="#1a1a1a"
      d="M1402 1262H102A100 100 0 012 1162v220a100 100 0 00100 100h1300a100 100 0 00100-100v-220a100 100 0 01-100 100z"
    />
    <path
      fill="#e6e6e6"
      d="M1402 1412H102A100 100 0 012 1312v10a100 100 0 00100 100h1300a100 100 0 00100-100v-10a100 100 0 01-100 100z"
    />
    <path
      fill="#e6e6e6"
      d="M1402 1332H102A100 100 0 012 1232v10a100 100 0 00100 100h1300a100 100 0 00100-100v-10a100 100 0 01-100 100z"
    />
    <path
      fill="#1a1a1a"
      d="M1402 932H102A100 100 0 012 832v220a100 100 0 00100 100h1300a100 100 0 00100-100V832a100 100 0 01-100 100z"
    />
    <path
      fill="#e6e6e6"
      d="M1402 1082H102A100 100 0 012 982v10a100 100 0 00100 100h1300a100 100 0 00100-100v-10a100 100 0 01-100 100z"
    />
    <path
      fill="#e6e6e6"
      d="M1402 1002H102A100 100 0 012 902v10a100 100 0 00100 100h1300a100 100 0 00100-100v-10a100 100 0 01-100 100z"
    />
    <path
      fill="#1a1a1a"
      d="M4462 1262H3162a100 100 0 01-100-100v220a100 100 0 00100 100h1300a100 100 0 00100-100v-220a100 100 0 01-100 100z"
    />
    <path
      fill="#e6e6e6"
      d="M4462 1412H3162a100 100 0 01-100-100v10a100 100 0 00100 100h1300a100 100 0 00100-100v-10a100 100 0 01-100 100z"
    />
    <path
      fill="#e6e6e6"
      d="M4462 1332H3162a100 100 0 01-100-100v10a100 100 0 00100 100h1300a100 100 0 00100-100v-10a100 100 0 01-100 100z"
    />
    <path
      fill="#1a1a1a"
      d="M4462 932H3162a100 100 0 01-100-100v220a100 100 0 00100 100h1300a100 100 0 00100-100V832a100 100 0 01-100 100z"
    />
    <path
      fill="#e6e6e6"
      d="M4462 1082H3162a100 100 0 01-100-100v10a100 100 0 00100 100h1300a100 100 0 00100-100v-10a100 100 0 01-100 100z"
    />
    <path
      fill="#e6e6e6"
      d="M4462 1002H3162a100 100 0 01-100-100v10a100 100 0 00100 100h1300a100 100 0 00100-100v-10a100 100 0 01-100 100z"
    />
    <g fill="#fff" opacity="0.15">
      <path d="M280.12 1572L457.92 1572 821.34 822 643.55 822 280.12 1572z" />
      <path d="M966.14 822L889.76 822 526.34 1572 602.71 1572 966.14 822z" />
    </g>
    <g fill="#fff" opacity="0.15">
      <path d="M1805.98 1572L1983.78 1572 2347.2 822 2169.41 822 1805.98 1572z" />
      <path d="M2492 822L2415.63 822 2052.2 1572 2128.57 1572 2492 822z" />
    </g>
    <g fill="#fff" opacity="0.15">
      <path d="M3342 1572L3519.8 1572 3883.22 822 3705.43 822 3342 1572z" />
      <path d="M4028.01 822L3951.64 822 3588.22 1572 3664.59 1572 4028.01 822z" />
    </g>
    <path
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      d="M2908.87 1612H2472v-40h-380v40h-436.87a83.22 83.22 0 00-83.13 83.13v603.74a83.22 83.22 0 0083.13 83.13H2092v1390h380V2382h436.87a83.22 83.22 0 0083.13-83.13v-603.74a83.22 83.22 0 00-83.13-83.13z"
    />
    <rect
      width="1500"
      height="940"
      x="1532"
      y="1572"
      fill="none"
      rx="123.13"
    />
    <rect
      width="1276"
      height="716"
      x="1642"
      y="1682"
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      rx="11.13"
    />
    <rect
      width="1276"
      height="716"
      x="1642"
      y="1694"
      fill="#ccc"
      stroke="gray"
      strokeWidth="4"
      rx="11.13"
    />
    <ellipse
      cx="2282"
      cy="2037.67"
      fill="#b3b3b3"
      stroke="gray"
      strokeWidth="4"
      rx="210"
      ry="114.33"
    />
    <ellipse
      cx="2282"
      cy="2031.33"
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      rx="210"
      ry="114.33"
    />
    <path
      fill="#b3b3b3"
      stroke="gray"
      strokeWidth="4"
      d="M2992 1604.28a83.22 83.22 0 00-83.11-82.28H2472v90h436.87a83.22 83.22 0 0183.13 83.13v-90-.85zM1655.13 1522a83.22 83.22 0 00-83.11 82.28v90.85a83.22 83.22 0 0183.13-83.13H2092v-90z"
    />
    <path
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      d="M3032 2298.87v-693.74A123.13 123.13 0 002908.87 1482H2472v40h436.87a83.22 83.22 0 0183.11 82.28v694.59h0M1572 2298.87h0v-693.74-.85a83.22 83.22 0 0183.11-82.28H2092v-40h-436.87A123.13 123.13 0 001532 1605.13v693.74"
    />

    <path
      fill="#ccc"
      stroke="#666"
      d="M2172 3492H2392V3532H2172z"
    />
    <path fill="#4d4d4d" d="M2172 3504H2392V3518H2172z" />
  </>
);

export const LabRailFgSprite = (
  <>
    <path
      fill="#ccc"
      stroke="gray"
      strokeWidth="4"
      d="M1462 90.85a122.67 122.67 0 01-83.11 32.28H942v90h436.87A123.13 123.13 0 001502 90V0a122.84 122.84 0 01-40 90.85zM125.13 123.13A122.67 122.67 0 0142 90.85 122.84 122.84 0 012 0v90a123.13 123.13 0 00123.13 123.13H522v-90z"
    />
    <path
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      d="M1462 0a83.22 83.22 0 01-83.13 83.13H942v680h40v-640h396.87A122.67 122.67 0 001462 90.85 122.84 122.84 0 001502 0M2 0a122.84 122.84 0 0040 90.85 122.67 122.67 0 0083.11 32.28H522v640h40v-680H125.13A83.22 83.22 0 0142 0"
    />
  </>
);

export const LabStatueSprite = (
  <>
    <path
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      d="M4 290.94v70c0 33.13 53.73 60 120 60s120-26.87 120-60v-70z"
    />
    <path
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      d="M4 326.94c0 33.13 53.73 60 120 60s120-26.87 120-60"
    />
    <ellipse
      cx="124"
      cy="290.94"
      fill="#f2f2f2"
      stroke="gray"
      strokeWidth="4"
      rx="120"
      ry="60"
    />
    <ellipse
      cx="124"
      cy="290.94"
      fill="#b3b3b3"
      stroke="gray"
      strokeWidth="4"
      rx="90"
      ry="40"
    />
    <image href={pizzaStatue} />
  </>
);

export const LabEntranceSprite = (
  <>
    <path
      fill="#1a1a1a"
      stroke="gray"
      strokeWidth="3"
      d="M191.5 1.5H381.5V291.5H191.5z"
    />
    <path
      fill="none"
      stroke="#999"
      strokeLinecap="round"
      strokeWidth="8"
      d="M221.5 141.5L221.5 191.5"
    />
    <path
      fill="#1a1a1a"
      stroke="gray"
      strokeWidth="3"
      d="M1.5 1.5H191.5V291.5H1.5z"
    />
    <g opacity="0.15">
      <path
        fill="none"
        d="M33.8 1.5L1.5 68.17 1.5 209.37 102.23 1.5 33.8 1.5z"
      />
      <path
        fill="none"
        d="M38.07 291.5L191.5 291.5 191.5 1.5 178.6 1.5 38.07 291.5z"
      />
      <path fill="#fff" d="M1.5 1.5L1.5 68.17 33.8 1.5 1.5 1.5z" />
      <path
        fill="#fff"
        d="M102.23 1.5L1.5 209.37 1.5 291.5 38.07 291.5 178.6 1.5 102.23 1.5z"
      />
    </g>
    <path
      fill="none"
      stroke="#999"
      strokeLinecap="round"
      strokeWidth="8"
      d="M161.5 141.5L161.5 191.5"
    />
  </>
);
